import { RemoteDataSource } from 'app/components/data/DataSource/Remote/RemoteDataSource';

/**
 * RemoteStaticDataSource for data that does requires http requests
 */
export class RemoteStaticDataSource<T extends object> extends RemoteDataSource<T> {
  protected getRecordsPromise: Promise<T[]>
  private lastInsertedBody: string

  createRecord(record: T, urlParams?: object): Promise<T> {
    return Promise.all([
      super.createRecord(record, urlParams),
      this.getAllRecords()
    ])
      .then(([newRecord, records]) => {
        records.push(newRecord)
        this.getRecordsPromise = Promise.resolve(records)

        this.sync()

        return newRecord
      })
  }

  removeRecord(record: T, urlParams?: object): Promise<boolean> {
    return Promise.all([
      super.removeRecord(record, urlParams),
      this.getAllRecords()
    ]).then(([wasRemoved, records]) => {
      if (wasRemoved) {
        const recordIndex = records.indexOf(record)

        if (recordIndex >= 0) {
          records.splice(recordIndex, 1)

          this.getRecordsPromise = Promise.resolve(records)

          this.sync()

          return true
        }
      }

      return false
    })
  }

  protected getAllRecords(): Promise<T[]> {
    const readConfig = this.config.transport.read

    if (readConfig.insertBodyBeforeRequest) {
      const insertedBody = readConfig.insertBodyBeforeRequest()
      readConfig.request = readConfig.request || {}

      if (insertedBody !== this.lastInsertedBody) {
        this.lastInsertedBody = insertedBody
        this.getRecordsPromise = null
      }

      readConfig.request.body = this.lastInsertedBody
    }

    if (!this.getRecordsPromise) {
      this.getRecordsPromise = this.fetch<T[]>(readConfig)
    }

    return this.getRecordsPromise
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Remote/Static/index.ts